import { render, staticRenderFns } from "./Fireworks.vue?vue&type=template&id=5aa0dbfc&scoped=true"
import script from "./Fireworks.vue?vue&type=script&lang=js"
export * from "./Fireworks.vue?vue&type=script&lang=js"
import style0 from "./Fireworks.vue?vue&type=style&index=0&id=5aa0dbfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa0dbfc",
  null
  
)

export default component.exports